<template>
  <v-tooltip class="help-tooltip" top>
    <template v-slot:activator="{ on }">
      <v-icon :class="{'tooltip-icon-inline': inline}" class="helpIcon" v-on="on">
        help_outline
      </v-icon>
    </template>
    <span><slot/></span>
  </v-tooltip>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";

@Component({
  components: {}
})
export default class HelpTooltip extends BasicComponent {

  @Prop(Boolean) inline: boolean;

}

</script>
<style lang="scss" scoped>

.helpIcon {
  cursor: help;
}

</style>
<style lang="scss">

.tooltip-icon-inline {
  display: inline !important;
}

</style>